import { ComponentWithContextProps } from 'lib/component-props';
import EEPlaceholder from 'components/Sections/EEPlaceholder';
import AlertMessageBase from 'components/Generic/AlertMessageBase';
import FundDetailsTabSkeleton from 'components/Pages/FundsCenter/FundDetails/FundDetailsTabSkeleton';
import { useI18n } from 'next-localization';
import useHelpers from 'hooks/helpers';
import { useSelector } from 'react-redux';
import { isFundDetailsImportantInfoAvailable } from '@/store/fundDetails';
import { useFetchFundDetailsImportantInformationQuery } from '@/store/fundDetails/services/fundDetailsApi';
import usePayload from 'hooks/useFundDetailsRequestPayload';

const FundDetailsImportantInfo = ({ sitecoreContext }: ComponentWithContextProps): JSX.Element => {
  const { t } = useI18n();
  const isExperienceEditor = sitecoreContext.pageEditing;
  const { getErrorDictionary } = useHelpers();
  const showImportantInfo: boolean = useSelector(isFundDetailsImportantInfoAvailable);
  const { shareClass, language, countryCode, correlationFundRangeId, site } = usePayload();
  const { data, error, isLoading } = useFetchFundDetailsImportantInformationQuery(
    {
      shareClass,
      language,
      countryCode,
      correlationFundRangeId,
      site,
    },
    {
      skip: isExperienceEditor || !shareClass,
    }
  );

  return (
    <section className="overflow-hidden">
      {showImportantInfo && (
        <div className="py-4 background-island text-white">
          <div className="container">
            <h5>{t('fundDetailsImportantInformation')}</h5>
            <div className="mt-3">
              {isLoading ? (
                <FundDetailsTabSkeleton />
              ) : error ? (
                <AlertMessageBase type="error" title={t(getErrorDictionary(error))} />
              ) : data.importantInformation ? (
                <p
                  className="body-small"
                  dangerouslySetInnerHTML={{ __html: data.importantInformation }}
                />
              ) : (
                <div className="body-small">{t('noResultsMessage')}</div>
              )}
            </div>
          </div>
        </div>
      )}
      {isExperienceEditor && <EEPlaceholder>Fund Details Important Information</EEPlaceholder>}
    </section>
  );
};

export default FundDetailsImportantInfo;
